module.exports = __webpack_public_path__ + "img/2b64c52.jpg";